/* Gratis gifts automatisch in de winkelwagen.

   De vorige versie haakte in op window.fetch. Dat was fout, en live gemeten
   ook aantoonbaar fout: een ander script op de pagina overschrijft fetch
   eveneens, en wie het laatst laadt wint. Bij de ene paginalading werkten de
   gifts daardoor wel en bij de volgende niet. Een race, geen bug die je met
   beter timen oplost.

   Nu raken we fetch niet meer aan en haken we in op het formulier, in de
   capture-fase op document. Capture loopt gegarandeerd vóór elke handler op
   het formulier zelf, ongeacht wie wanneer laadt. Op document en niet op het
   element, zodat het blijft werken als Shrine de sectie opnieuw rendert bij
   een variantwissel.

   De dans is: eerste submit tegenhouden, gifts in de wagen zetten, formulier
   opnieuw indienen. Die tweede ronde laten we door, dus Shrine handelt 'm
   normaal af inclusief hun eigen wagen-verversing.

   Dat werkt ongeacht wie de tweede ronde afhandelt. Onze capture-listener op
   document draait sowieso vóór Shrine's listener, die op het formulier zelf
   zit. Zowel de koopknop boven aan de pagina als de slot-CTA zijn een
   <product-form>: ronde twee komt daar aan, wordt via fetch afgehandeld en de
   cart-drawer schuift open. Valt Shrine's script uit, dan is het een gewone
   post naar /cart en heb je nog steeds je gifts, alleen zonder drawer.

   /cart/update.js en niet /cart/add.js: update ZET de hoeveelheid in
   plaats van er bij op te tellen. Het aantal gifts volgt het quantity-veld
   in het formulier: voeg je 2 apparaten toe, dan gaan er 2 van elke gift
   mee. Een Shopify BXGY-korting maakt ze gratis (per apparaat 1 set).
   Dubbelklikken kan de gifts niet verdubbelen.

   Zonder JavaScript werkt add-to-cart gewoon, alleen zonder de gifts. Daarom
   staat de dynamic-checkoutknop uit: die slaat de wagen over, en dan is er
   geen moment waarop we er nog iets bij kunnen leggen.
*/
(function () {
  // Twee secties kunnen dit script binnenhalen: de offer-stack en de slot-CTA,
  // en op de productpagina staan ze allebei. Dan draait dit bestand twee keer
  // en zet het twee listeners neer. Dat is niet dubbelop maar kapot: ronde twee
  // haalt de vlag weg en laat door, waarna de tweede listener geen vlag meer
  // ziet, opnieuw onderschept en de vlag weer zet. Het formulier blijft dan
  // rondjes draaien. Eerste keer wint, de rest doet niets.
  if (window.__komforaGiftsLoaded) return;
  window.__komforaGiftsLoaded = true;

  var root = document.querySelector('[data-komfora-gifts]');
  if (!root) return;

  var GIFTS = (root.getAttribute('data-komfora-gifts') || '')
    .split(',')
    .map(function (s) {
      return parseInt(s.trim(), 10);
    })
    .filter(function (n) {
      return n > 0;
    });

  if (!GIFTS.length) return;

  var isGift = {};
  GIFTS.forEach(function (id) {
    isGift[id] = true;
  });

  function ensureGifts(multiplier) {
    var updates = {};
    GIFTS.forEach(function (id) {
      updates[id] = multiplier;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action*="/cart/add"]')) return;

      // Tweede ronde: vlag weghalen en doorlaten, dan doet Shrine z'n werk.
      if (form.dataset.komforaGiftsReady) {
        delete form.dataset.komforaGiftsReady;
        return;
      }

      // Een gift die los wordt toegevoegd hoeft niet de hele stapel mee.
      var idField = form.querySelector('[name="id"]');
      if (idField && isGift[parseInt(idField.value, 10)]) return;

      var qtyField = form.querySelector('[name="quantity"]');
      var multiplier = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;

      e.preventDefault();
      e.stopImmediatePropagation();

      ensureGifts(multiplier)
        .catch(function () {
          // Gifts mogen nooit de gewone add-to-cart blokkeren. Liever een
          // bestelling zonder cadeaus dan een knop die niets doet.
        })
        .then(function () {
          form.dataset.komforaGiftsReady = '1';
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
    },
    true
  );
})();
